
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"zooplaComparableSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZooplaComparableSearchInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"200"},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zooplaComparableSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uprn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyNumberOrName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"streetName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locality"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"townOrCity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"propertySubType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newBuild"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yearBuilt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floorArea"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"valuation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastValueType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastValueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentValuePerSqft"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sale"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastValueType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastValueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentValuePerSqft"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1025}};
    doc.loc.source = {"body":"query zooplaComparableSearch($search: ZooplaComparableSearchInput!, $limit: Int = 200) {\n  zooplaComparableSearch(search: $search, limit: $limit) {\n    totalCount\n    edges {\n      _id\n      node {\n        uprn\n        location {\n          address {\n            propertyNumberOrName\n            streetName\n            locality\n            townOrCity\n            postcode\n            countryCode\n          }\n          coordinates\n        }\n        attributes {\n          propertyType\n          propertySubType\n          bedrooms\n          receptions\n          bathrooms\n          newBuild\n          yearBuilt\n          tenure\n          floorArea\n        }\n        valuation {\n          rent {\n            lastValue\n            lastValueType\n            lastValueDate\n            currentValue\n            currentValuePerSqft\n          }\n          sale {\n            lastValue\n            lastValueType\n            lastValueDate\n            currentValue\n            currentValuePerSqft\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["zooplaComparableSearch"] = oneQuery(doc, "zooplaComparableSearch");
        
